import React, { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getNumberFromString, getVariantDiscount } from "../utils/helpers";

export const CartContext = createContext();

const CartContextFunction = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    const [actionCount, setActionCount] = useState(1);
    const [discounts, setDiscounts] = useState([]);
    const [deliveryCharge, setDeliveryCharge] = useState(2.0);
    // const [itemGroups, setItemGroups] = useState([]);
    const [rpDiscount, setRPDiscount] = useState(0);
    const [tips, setTips] = useState(0);
    const [deliveryType, setDeliveryType] = useState("Standard Free Delivery");
    const [paymentMethod, setPaymentMethod] = useState("card");
    const [deliveryMethod, setDeliveryMethod] = useState("dpd");
    const [saved, setSaved] = useState(0.0);

    //running useEffect to get existing cartData from local storage
    useEffect(() => {
        if (localStorage.getItem("the_cart") != null) {
            setCartItems(JSON.parse(localStorage.getItem("the_cart")));
        }
    }, []);

    useEffect(() => {
        let amount = 0.0;
        cartItems.forEach((item) => {
            amount = amount + parseFloat(getVariantDiscount(item.variant));
        });

        setSaved(parseFloat(amount).toFixed(2));
    }, [cartItems]);

    useEffect(() => {
        if (deliveryType === "ed") {
            setDeliveryCharge(3.5);
            return;
        }
        if (calculateOrderSubTotal() > 49) {
            setDeliveryCharge(0.0);
        } else {
            setDeliveryCharge(4.95);
        }
    }, [cartItems, actionCount]);

    //defining addToCart function
    const addToCart = (product) => {
        const existingItem = cartItems.find(item => item.id === product.id);

        if (existingItem) {
            if (existingItem.stock >= existingItem.quantity + 1) {
                existingItem.quantity++;
                toast.success("Product updated to cart");
            } else {
                console.log("not eno", product.stock, existingItem.quantity + 1);
                toast.error(`Currently we only have ${product.stock} unit of this product in stock!`);
            }
        } else {
            cartItems.push({ ...product, quantity: 1 });
            toast.success("Product added to cart");
        }

        setActionCount(actionCount + 1);
        localStorage.setItem("the_cart", JSON.stringify(cartItems));
    };

    //defining remove from cart function
    const removeFromCart = (productID) => {
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].id === productID) {
                const index = cartItems.indexOf(cartItems[i]);
                // console.log(index);
                cartItems.splice(index, 1);
            }
        }

        setActionCount(actionCount + 1);

        toast.success("Product removed from cart");

        //updating cartData in local storage
        localStorage.setItem("the_cart", JSON.stringify(cartItems));
    };

    //defining cartItemDecrement function
    const cartItemDecrement = (productID) => {
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].id === productID) {
                // console.log(cartItems[i]);
                cartItems[i].quantity = parseInt(cartItems[i].quantity) - 1;

                //whenever productItem quantity reaches zero i'm removing it cart
                if (cartItems[i].quantity === 0) {
                    removeFromCart(cartItems[i].id);
                }

                setActionCount(actionCount + 1);

                //updating cartData in local storage
                localStorage.setItem("the_cart", JSON.stringify(cartItems));
            }
        }
    };

    const calculateOrderSubTotal = () => {
        let subTotal = 0;
        for (let i = 0; i < cartItems.length; i++) {
            subTotal = subTotal + cartItems[i].order_time_price * cartItems[i].quantity;
        }

        return subTotal;
    };

    //defining calculateRewardPoints
    const calculateRewardPoints = () => {
        let subTotal = 0;
        for (let i = 0; i < cartItems.length; i++) {
            subTotal = subTotal + cartItems[i].order_time_price * cartItems[i].quantity;
        }

        return subTotal;
    };

    //defining calculateGroceryTotal function
    const calculateGroceryTotal = () => {
        let groceryTotal = 0;
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].category_slug === process.env.grocerySlug) {
                groceryTotal = groceryTotal + cartItems[i].order_time_price * cartItems[i].quantity;
            }
        }

        return groceryTotal;
    };

    //9.00 percent
    const calculateVatA = () => {
        let vat = 0.0;
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].product?.tax_rate == 7.0) {
                // vat = vat + (((cartItems[i].product?.tax_rate * cartItems[i].order_time_price) / 100) * cartItems[i].quantity);
                vat = vat + cartItems[i].order_time_price * cartItems[i].quantity * 0.07;
            }
        }

        return Math.ceil(vat * 100) / 100;
    };

    //17.00 percent
    const calculateVatB = () => {
        let vat = 0.0;
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].product?.tax_rate == 19.0) {
                // vat = vat + (((cartItems[i].product?.tax_rate * cartItems[i].order_time_price) / 100) * cartItems[i].quantity);
                vat = vat + cartItems[i].order_time_price * cartItems[i].quantity * 0.19;
            }
        }

        return Math.ceil(vat * 100) / 100;
    };

    const getArticleACount = () => {
        let count = 0;
        for (let i = 0; i < cartItems.length; i++) {
            // console.log(cartItems[i].product.tax_rate)
            if (cartItems[i].product?.tax_rate == 7.0) {
                count = count + 1;
            }
            // console.log((cartItems[i].product?.tax_rate * cartItems[i].order_time_price) / 100);
        }
        return count;
    };

    const getArticleBCount = () => {
        let count = 0;
        for (let i = 0; i < cartItems.length; i++) {
            // console.log(cartItems[i].product.tax_rate)
            if (cartItems[i].product?.tax_rate == 19.0) {
                count = count + 1;
            }
            // console.log((cartItems[i].product?.tax_rate * cartItems[i].order_time_price) / 100);
        }

        return count;
    };

    //defining vat calculator
    const calculateVat = () => {
        return calculateVatA() + calculateVatB();
    };

    const calculateOrderSubTotalExclVat = () => {
        let subTotal = 0;
        for (let i = 0; i < cartItems.length; i++) {
            subTotal = subTotal + cartItems[i].order_time_price * cartItems[i].quantity;
        }

        return subTotal - calculateVat();
    };

    //defining calculateOrderTotal
    const calculateOrderTotal = () => {
        // console.log('total discount', totalDiscount);
        let orderTotal = calculateOrderSubTotal() + deliveryCharge - rpDiscount + tips;

        return parseFloat(orderTotal).toFixed(2);
    };

    //defining emptyCart function
    const emptyCart = () => {
        setCartItems([]);
        localStorage.setItem("the_cart", JSON.stringify([]));
    };

    const getTotalCartWeight = () => {
        let total_weight = 0; //in KG

        cartItems.forEach((item) => {
            if (item.variant.type === "weight_g") {
                total_weight = total_weight + (getNumberFromString(item.variant.value) * item.quantity) / 1000;
            } else if (item.variant.type === "weight_kg") {
                total_weight = total_weight + getNumberFromString(item.variant.value) * item.quantity;
            } else if (item.variant.type === "weight") {
                if (item.variant.value.toLowerCase().includes("kg")) {
                    total_weight = total_weight + getNumberFromString(item.variant.value) * item.quantity;
                } else {
                    total_weight = total_weight + (getNumberFromString(item.variant.value) * item.quantity) / 1000;
                }
            }
        });

        return Math.ceil(total_weight * 100) / 100;
    };

    return (
        <CartContext.Provider
            value={{
                addToCart,
                cartItems,
                setCartItems,
                setActionCount,
                removeFromCart,
                cartItemDecrement,
                discounts,
                setDiscounts,
                calculateOrderTotal,
                calculateOrderSubTotal,
                deliveryCharge,
                setDeliveryCharge,
                emptyCart,
                calculateGroceryTotal,
                // itemGroups,
                calculateVat,
                calculateVatA,
                calculateVatB,
                rpDiscount,
                setRPDiscount,
                calculateRewardPoints,
                tips,
                setTips,
                deliveryType,
                setDeliveryType,
                getArticleACount,
                getArticleBCount,
                getTotalCartWeight,
                deliveryMethod,
                setDeliveryMethod,
                paymentMethod,
                setPaymentMethod,
                calculateOrderSubTotalExclVat,
                saved,
                setSaved,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export default CartContextFunction;
